import moment from "moment";

import { KontaxTransactionFilterOptions } from "../../types";

export const getDefaultFilterState = (): KontaxTransactionFilterOptions => ({
  escalated: false,
  dateFrom: moment().subtract(3, "months").format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  vatPaymentFrequency: undefined,
  plans: undefined,
  vatCategoryCodes: undefined,
  categories: undefined,
});
